<template>
  <CreateSupplierDocumentModal
    v-if="showCreateSupplierDocumentModal"
    :supplier="supplier"
    @closeModal="closeModal"
  />
  <ReplaceSupplierDocumentModal
    v-if="showReplaceSupplierDocumentModal"
    :document="selectedDocument"
    @closeModal="closeModal"
  />
  <UpdateSupplierDocumentModal
    v-if="showUpdateSupplierDocumentModal"
    :supplier="supplier"
    :document="selectedDocument"
    @closeModal="closeModal"
  />
  <p>
    <strong>Nome:</strong>
    {{ supplier.supplierName }} |
    <strong>CPF/CNPJ:</strong>
    {{ supplier.supplierDocument }}
    <span role="button" class="badge bg-info" @click="copyCnpj">
      Copiar CNPJ
    </span>
  </p>
  <hr class="my-2" />
  <div class="d-flex justify-content-between mb-3">
    <h6 class="fw-semibold d-flex align-items-center mb-0">
      Documentos do Fornecedor
    </h6>
    <button
      class="btn btn-success rounded-pill"
      title=" Adicionar Documento"
      @click="showCreateSupplierDocumentModal = true"
    >
      Adicionar Documento
    </button>
  </div>
  <div v-if="documents.length > 0">
    <div class="table-responsive">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th>Nome</th>
            <th class="text-center">Valido Até</th>
            <th class="text-center">Vencimento</th>
            <th class="text-center">Obsoleto</th>
            <th class="text-end">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="document in documents" :key="document.id">
            <td>{{ document.name }}</td>
            <td class="text-center">
              {{ dateTimeSqlToDateBR(document.expireAt) }}
            </td>
            <td class="text-center">
              <span v-html="compare2Dates(new Date(), document.expireAt)" />
            </td>
            <td
              class="text-center"
              v-html="spanIsObsoleted(document.isObsoleted)"
            />
            <td class="text-end">
              <button
                class="btn badge bg-secondary my-1"
                title="Substituir Documento"
                @click="replaceDocument(document)"
              >
                Substituir Documento
              </button>
              <button
                class="btn badge bg-warning my-1 ms-2"
                title="Editar"
                @click="updateDocument(document)"
              >
                Editar
              </button>
              <a
                :href="`${pathFile}/${removeCnpjCharacteres(
                  supplier.supplierDocument,
                )}/${document.file}`"
                class="btn badge bg-primary my-1 ms-2"
                title="Download"
                target="_blank"
                download
              >
                Download
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <p v-else class="text-center mb-0">
    Nenhum documento cadastrado para este fornecedor
  </p>
</template>

<script>
import CreateSupplierDocumentModal from '@/components/documents/suppliers/CreateSupplierDocumentModal.vue'
import ReplaceSupplierDocumentModal from '@/components/documents/suppliers/ReplaceSupplierDocumentModal.vue'
import UpdateSupplierDocumentModal from '@/components/documents/suppliers/UpdateSupplierDocumentModal.vue'
import { dateTimeSqlToDateBR, compare2Dates } from '@/utils/date'
import { spanIsObsoleted, removeCnpjCharacteres } from '@/utils/strings'

export default {
  name: 'SupplierDocuments',

  props: {
    supplier: {
      type: Object,
      required: true,
    },
    documents: {
      type: Array,
      required: true,
    },
  },

  components: {
    CreateSupplierDocumentModal,
    ReplaceSupplierDocumentModal,
    UpdateSupplierDocumentModal,
  },

  emits: ['getSupplierDocuments'],

  data() {
    return {
      showCreateSupplierDocumentModal: false,
      showReplaceSupplierDocumentModal: false,
      showUpdateSupplierDocumentModal: false,
      selectedDocument: {
        id: null,
        supplierType: this.supplier.supplierType,
        supplierName: this.supplier.supplierName,
        supplierDocument: this.supplier.supplierDocument,
        file: '',
        name: '',
        isObsoleted: false,
        expireAt: null,
      },
      dateTimeSqlToDateBR,
      compare2Dates,
      removeCnpjCharacteres,
      spanIsObsoleted,
      pathFile: `${process.env.VUE_APP_BASE_URL_API}/uploads/suppliers`,
    }
  },

  methods: {
    replaceDocument(document) {
      this.selectedDocument = document
      this.showReplaceSupplierDocumentModal = true
    },

    updateDocument(document) {
      this.selectedDocument = document
      this.showUpdateSupplierDocumentModal = true
    },

    closeModal(reloadListDocuments) {
      if (reloadListDocuments) {
        this.$emit('getSupplierDocuments')
      }
      this.showCreateSupplierDocumentModal = false
      this.showReplaceSupplierDocumentModal = false
      this.showUpdateSupplierDocumentModal = false
    },

    copyCnpj() {
      try {
        const clip = document.createElement('input')
        clip.setAttribute('type', 'text')
        clip.value = this.supplier.supplierDocument
        document.body.appendChild(clip)
        clip.select()
        document.execCommand('copy')
        document.body.removeChild(clip)
        this.$root.$refs.notification.success(
          `CNPJ ${this.supplier.supplierDocument} copiado!`,
        )
      } catch (e) {
        this.$root.$refs.notification.warning(
          `Não foi possível copiar o CNPJ ${this.supplier.supplierDocument} para área de transferência. Erro: ${e}`,
        )
      }
    },
  },
}
</script>
